import React from 'react';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateSalesInvoiceDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import DictionarySelector from '../Selects/DictionarySelector';
import { Option } from '../Selects/Selector';
import DictionaryMultiSelector from '../Selects/DictionaryMultiSelector';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface SalesInvoiceFormCodesProps {
  salesInvoice: CreateUpdateSalesInvoiceDto;
  propertyChange: (obj: Partial<CreateUpdateSalesInvoiceDto>) => void;
  readOnly?: boolean;
}

export const SalesInvoiceFormCodes: React.FC<SalesInvoiceFormCodesProps> = ({
  salesInvoice,
  propertyChange,
  readOnly,
}) => {
  const { t, tk } = useTranslation('fvsLng');
  return (
    <>
      <FormRow controlId="documentCodeIds" label={t(tk.finance.documentCodes)}>
        <DictionaryMultiSelector
          dictionary="Kody dokumentu"
          value={salesInvoice?.documentCodeIds}
          onChange={options =>
            propertyChange({
              documentCodeIds:
                (options as Option[])?.map(({ value }) => value) || [],
            })
          }
          readOnly={readOnly}
        />
      </FormRow>
      <FormRow controlId="gtuCodeId" label={t(tk.finance.gtuCode)}>
        <DictionarySelector
          dictionary="Kody GTU"
          value={salesInvoice?.gtuCodeId}
          onChange={option =>
            propertyChange({
              gtuCodeId: option.value,
            })
          }
          clearable
          readOnly={readOnly}
        />
      </FormRow>
    </>
  );
};
